/* Amit Pasha — small designed combobox (v2) for form fields (birthday MM / DD / YYYY, phone country code, …).
   Markup: <div class="combo" data-combo …><input class="combo__input" …><ul class="combo__list" role="listbox"></ul></div>
     data-min / data-max / data-pad   numeric range (e.g. 1–12, pad 2 → 01…12); data-desc = newest first (years)
     data-options='[["+972","+972 Israel"],…]'   fixed options [value, label]
     data-labels='["Jan",…]'          extra text after each numeric option
     data-next="#id"                  field to jump to after a choice
   The input stays a real text field: people can type (the list filters as they type; for years "9" → the 1990s, "98" → 1998), pick with the
   mouse or the arrow keys + Enter, and on leaving the field "1" becomes "01", "90" becomes "1990". Out of range → marked invalid. */
(function () {
  'use strict';
  var uid = 0;
  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }

  function Combo(root) {
    var input = root.querySelector('.combo__input'), list = root.querySelector('.combo__list');
    if (!input || !list || root._combo) return; root._combo = this;
    var id = input.id || ('combo-' + (++uid)); input.id = id; list.id = id + '-list';
    var min = +root.getAttribute('data-min'), max = +root.getAttribute('data-max'), w = +root.getAttribute('data-pad') || 0;
    var numeric = root.hasAttribute('data-min'), readonly = input.readOnly, labels = [], opts = [], active = -1, shown = [];
    try { labels = JSON.parse(root.getAttribute('data-labels') || '[]'); } catch (e) {}
    if (numeric) {
      for (var n = min; n <= max; n++) opts.push([w ? pad(n, w) : String(n), (w ? pad(n, w) : String(n)) + (labels[n - min] ? ' · ' + labels[n - min] : '')]);
      if (root.hasAttribute('data-desc')) opts.reverse();
    } else { try { opts = JSON.parse(root.getAttribute('data-options') || '[]'); } catch (e) {} }

    input.setAttribute('role', 'combobox'); input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id); input.setAttribute('aria-autocomplete', readonly ? 'none' : 'list');
    list.setAttribute('role', 'listbox');

    function render(filter) {
      var q = readonly ? '' : (filter || '').replace(/\s/g, '').toLowerCase(), q2 = q.replace(/^0+/, '');
      shown = opts.filter(function (o) {
        if (!q) return true;
        var v = o[0].toLowerCase(), l = o[1].toLowerCase();
        return v.indexOf(q) === 0 || (q2 && v.replace(/^0+/, '').indexOf(q2) === 0) || (!numeric && l.indexOf(q) > -1) || (numeric && v.length === 4 && q.length <= 2 && v.slice(2).indexOf(q) === 0);
      });
      list.innerHTML = shown.map(function (o, i) {
        return '<li class="combo__opt" role="option" id="' + id + '-o' + i + '" data-i="' + i + '" aria-selected="' + (o[0] === input.value) + '">' + o[1] + '</li>';
      }).join('');
      active = -1;
      for (var i = 0; i < shown.length; i++) if (shown[i][0] === input.value) active = i;
      if (active < 0 && q && shown.length) active = 0;
      mark(true);
      return shown.length;
    }
    function mark(scroll) {
      var items = list.children;
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-active', i === active);
      if (active > -1 && items[active]) {
        input.setAttribute('aria-activedescendant', items[active].id);
        if (scroll) { var el = items[active]; list.scrollTop = el.offsetTop - list.clientHeight / 2 + el.offsetHeight / 2; }
      } else input.removeAttribute('aria-activedescendant');
    }
    function open(filter) {
      if (!render(filter)) { close(); return; }
      var r = input.getBoundingClientRect(), below = window.innerHeight - r.bottom;
      root.classList.toggle('is-up', below < 200 && r.top > below);
      root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
      mark(true);
      var start = root.getAttribute('data-start');   // nothing chosen yet → show the list around a sensible value (e.g. 1990)
      if (active < 0 && start) { var el = list.querySelector('[data-i="' + shown.map(function (o) { return o[0]; }).indexOf(start) + '"]'); if (el) list.scrollTop = el.offsetTop - list.clientHeight / 2; }
    }
    function close() { root.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    function choose(i, advance) {
      var o = shown[i]; if (!o) return;
      input.value = o[0]; setValid(true); close();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (advance !== false) next();
    }
    function next() {
      var sel = root.getAttribute('data-next'), el = sel && document.querySelector(sel);
      if (el && !el.value) el.focus();
    }
    function setValid(ok) { input.classList.toggle('is-error', !ok); if (ok) input.removeAttribute('aria-invalid'); else input.setAttribute('aria-invalid', 'true'); }
    function normalize() {
      var v = input.value.trim(); if (!v) { setValid(true); return; }
      if (!numeric) { var hit = opts.filter(function (o) { return o[0] === v; })[0]; setValid(!!hit); return; }
      var d = v.replace(/\D/g, ''); if (!d) { setValid(false); return; }
      var n = parseInt(d, 10);
      if (w === 4 && d.length <= 2) { var yy = new Date().getFullYear() % 100; n = n > yy ? 1900 + n : 2000 + n; }   // "90" → 1990
      if (n < min || n > max) { setValid(false); return; }
      input.value = w ? pad(n, w) : String(n); setValid(true);
    }

    input.addEventListener('focus', function () { open(''); });
    input.addEventListener('click', function () { if (!root.classList.contains('is-open')) open(''); });
    input.addEventListener('input', function () {
      if (numeric) input.value = input.value.replace(/\D/g, '');
      setValid(true); open(input.value);
      // typed the full value ("03", "1990") and it is valid → take it and move on
      var ml = +input.getAttribute('maxlength') || 0;
      if (numeric && ml && input.value.length >= ml) { normalize(); if (!input.classList.contains('is-error')) { close(); next(); } }
    });
    input.addEventListener('keydown', function (e) {
      var isOpen = root.classList.contains('is-open');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!isOpen) { open(''); return; }
        var len = list.children.length; if (!len) return;
        active = e.key === 'ArrowDown' ? (active + 1) % len : (active <= 0 ? len - 1 : active - 1); mark(true);
      } else if (e.key === 'Enter' && isOpen && active > -1) { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape' && isOpen) { e.preventDefault(); e.stopPropagation(); close(); }
      else if (e.key === 'Tab') { close(); }
      else if (readonly && e.key.length === 1) {   // fixed lists: jump to the first option starting with the key
        var k = e.key.toLowerCase(); for (var i = 0; i < shown.length; i++) if (shown[i][1].toLowerCase().replace(/^\+/, '').indexOf(k) === 0 || shown[i][1].toLowerCase().indexOf(k) === 0) { active = i; mark(true); break; }
      }
    });
    input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) { close(); normalize(); input.dispatchEvent(new Event('combo:blur', { bubbles: true })); } }, 120); });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });   // keep focus in the field
    list.addEventListener('mousemove', function (e) { var li = e.target.closest('.combo__opt'); if (li && +li.getAttribute('data-i') !== active) { active = +li.getAttribute('data-i'); mark(false); } });
    list.addEventListener('click', function (e) { var li = e.target.closest('.combo__opt'); if (li) choose(+li.getAttribute('data-i')); });

    this.normalize = normalize; this.setValid = setValid; this.input = input;
  }

  function init(scope) { (scope || document).querySelectorAll('[data-combo]').forEach(function (r) { new Combo(r); }); }
  init();
  window.theme = window.theme || {}; window.theme.combo = { init: init };
})();
